import BotMessage from './BotResponse'
import Button from './Button'
import Slide from './Slide'
import Carousel from './Carousel'
import Menu from './Menu'
import Message from './Message'

export {
  BotMessage,
  Button,
  Slide,
  Carousel,
  Menu,
  Message,
}



// WEBPACK FOOTER //
// ./src/App/services/types/index.js